<template>
  <sc-page title="数据统计">
    <div class="main-container">
      <a-row :gutter="[16, 16]">
        <a-col :md="24" :lg="12">
          <chart title="交易" name="transactionAmount" />
        </a-col>
        <a-col :md="24" :lg="12">
          <chart title="订单" name="transactionAmount" />
        </a-col>
      </a-row>
    </div>
  </sc-page>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Chart from '@/views/aggregate/Chart.vue';

export default defineComponent({
  name: 'Index',
  components: { Chart },
  data() {
    return {};
  },
  computed: {},
  methods: {},
});
</script>

<style lang="scss" scoped>
.main-container {
  padding: $spacing-medium;
}
</style>
